import { create } from 'zustand';

// Drives the thin blue progress bar that lives on the TopNav's bottom border.
// The API client brackets every request with begin()/end(); `inflight` is a
// count so overlapping requests (e.g. a search that fans out to destinations +
// hotels) keep the bar alive until the last one settles. `tick` lets a caller
// flash the bar for work the client doesn't wrap — a route transition that
// doesn't itself hit the network — by nudging it on then off.
type LoadingBarState = {
    inflight: number;
    begin: () => void;
    end: () => void;
    pulse: () => void;
};

export const useLoadingBar = create<LoadingBarState>((set) => ({
    inflight: 0,
    begin: () => set((state) => ({ inflight: state.inflight + 1 })),
    end: () => set((state) => ({ inflight: Math.max(0, state.inflight - 1) })),
    // A self-clearing blip for non-network navigations. 600ms is long enough
    // for the bar to read as "loading" and short enough to never strand it on.
    pulse: () => {
        set((state) => ({ inflight: state.inflight + 1 }));
        setTimeout(() => set((state) => ({ inflight: Math.max(0, state.inflight - 1) })), 600);
    },
}));
